import { Injectable } from '@angular/core';
import { ResourceBaseUrlBuilder } from '@core/api/resource-base-url-builder';
import { ClientNamespacedResourceBaseUrlBuilder } from '@core/client-namespaced-resource-base-url-builder.service';
import { OrganizationQuery } from '@core/organization/organization.query';
import { standardizeUrl } from '@core/utils';

@Injectable({ providedIn: 'root' })
export class ClientDataroomResourceBaseUrlBuilder implements ResourceBaseUrlBuilder {
  constructor(
    private readonly userNamespacedBuilder: ClientNamespacedResourceBaseUrlBuilder,
    private readonly organizationQuery: OrganizationQuery,
  ) {}

  public buildBaseUrl(append?: string): string {
    const url = this.userNamespacedBuilder.buildBaseUrl(append);

    // KAP-1893: in the fund DDQ runs view the namespace is the Issuer's
    // (emittents/{issuer}/...), so that product calls work for an investor. The
    // client's own data room is not served under that namespace as
    // emittents/{issuer}/clients/{client}/...: the Issuer side only has the singular
    // emittents/{issuer}/client/{client}/... route, for Issuer staff and for clients
    // with an accepted investment. The request therefore answered 404. An investor's
    // client data room lives at investors/{investor}/clients/{client}/..., which
    // checks the client's own data room read/write permission.
    const organization = this.organizationQuery.getActive();
    // Only the plural `clients/` route is rewritten: the singular `client/` route of
    // the envelope views has no investors counterpart.
    const issuerNamespace = /^\/?emittents\/[^/]+(?=\/clients\/)/;
    if (organization?.type === 'investor' && organization.id && issuerNamespace.test(url)) {
      return standardizeUrl(url.replace(issuerNamespace, `investors/${organization.id}`));
    }

    return standardizeUrl(url);
  }
}
